import React, { useState } from "react";
import { useMediaQuery } from "beautiful-react-hooks";
import BottomHeader from "./elements/BottomHeader";
import CategoriesNav from "./elements/CategoriesNav";
import Logo from "./elements/Logo";
import SearchForm from "./elements/SearchForm";
import TopHeader from "./elements/TopHeader";

import "./styles.scss";
import data from "./data";
import { useStaticQuery, graphql } from "gatsby";
import { set } from "date-fns";

export const query = graphql`
  query {
    api {
      menu {
        id
        menus {
          id
          label {
            type
            uri
            article {
              slug
              category {
                ...ArticleCategoryFragment
              }
            }
            category {
              slug
              parentCategory {
                ...Category
                slug
                title {
                  id
                  text_en
                  text_sq
                }
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    title {
                      id
                      text_en
                      text_sq
                    }
                    slug
                    parentCategory {
                      ...Category
                      slug
                      title {
                        id
                        text_en
                        text_sq
                      }
                    }
                  }
                }
              }
            }
            label {
              id
              text_sq
              text_en
            }
          }
          image {
            url
          }
          columns {
            id
            head {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
            body {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
          }
        }
      }
      businessMenu: configMenuBusiness {
        id
        menus {
          id
          label {
            type
            uri
            article {
              slug
              category {
                ...ArticleCategoryFragment
              }
            }
            category {
              slug
              parentCategory {
                ...Category
                slug
                title {
                  id
                  text_en
                  text_sq
                }
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    title {
                      id
                      text_en
                      text_sq
                    }
                    slug
                    parentCategory {
                      ...Category
                      slug
                      title {
                        id
                        text_en
                        text_sq
                      }
                    }
                  }
                }
              }
            }
            label {
              id
              text_sq
              text_en
            }
          }
          image {
            url
          }
          columns {
            id
            head {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
            body {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
          }
        }
      }
      aboutUsMenu: configMenuAboutUs {
        id
        menus {
          id
          label {
            type
            uri
            article {
              slug
              category {
                ...ArticleCategoryFragment
              }
            }
            category {
              slug
              parentCategory {
                ...Category
                slug
                title {
                  id
                  text_en
                  text_sq
                }
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    title {
                      id
                      text_en
                      text_sq
                    }
                    slug
                    parentCategory {
                      ...Category
                      slug
                      title {
                        id
                        text_en
                        text_sq
                      }
                    }
                  }
                }
              }
            }
            label {
              id
              text_sq
              text_en
            }
          }
          image {
            url
          }
          columns {
            id
            head {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
            body {
              type
              uri
              article {
                slug
                category {
                  ...ArticleCategoryFragment
                }
              }
              category {
                slug
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                  parentCategory {
                    ...Category
                    slug
                    title {
                      id
                      text_en
                      text_sq
                    }
                    parentCategory {
                      ...Category
                      title {
                        id
                        text_en
                        text_sq
                      }
                      slug
                      parentCategory {
                        ...Category
                        slug
                        title {
                          id
                          text_en
                          text_sq
                        }
                      }
                    }
                  }
                }
              }
              label {
                id
                text_sq
                text_en
              }
            }
          }
        }
      }
    }
  }
`;

export default function Header({ children }) {
  const apiData = useStaticQuery(query);
  const categories = apiData.api.menu.menus;
  const businessCategories = (apiData.api.businessMenu || {}).menus || [];
  const aboutUsCategories = (apiData.api.aboutUsMenu || {}).menus || [];

  const [isSearching, setSearching] = useState(false);
  const [isExpanded, setExpanded] = useState(false);

  const mediaDesktop = useMediaQuery("(min-width: 1025px)");
  const mediaTablet = useMediaQuery(
    "(min-width: 769px) and (max-width: 1024px)"
  );
  const mediaMobile = useMediaQuery(
    "(min-width: 320px) and (max-width: 768px)"
  );

  const headerClasses = [
    "header",
    "header--corporate",
    (mediaTablet || mediaMobile) && "header--mobile",
    isExpanded && "header--expanded",
  ];

  return (
    <header className={headerClasses.join(" ")}>
      <TopHeader onShowSearch={() => setSearching(true)} data={data} />

      <div className="wrapper">
        <div className="header-wrapper">
          <Logo />
          <CategoriesNav
            onToggle={() => {
              setExpanded(!isExpanded);
            }}
            onClose={() => {
              setExpanded(false);
            }}
            isExpanded={isExpanded}
            categories={categories}
            businessCategories={businessCategories}
            aboutUsCategories={aboutUsCategories}
          />

          {(mediaMobile || mediaTablet || isSearching) && (
            <SearchForm onHideSearch={() => setSearching(false)} />
          )}
        </div>
      </div>

      {/* <BottomHeader data={data.bottomHeader} /> */}
    </header>
  );
}
